
<div class="subBlockContainer componentContainer">
  <div class="subBlockContent componentContent">
   
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="page-title-position">
          {{title}} - {{reportType}}
        </div>
        <i class="material-icons pullfloat-right" (click)="close()">close</i>
      </div>
      <div class="top-divider"></div>
<!-- <div class="blockContainer filter-selection" id="levelThree"> -->
  <!-- <div class="pageTitle">
      {{title}}
      <i class="material-icons pullfloat-right" (click)="close()">close</i>
  </div> -->
  <div class="container">
    <div style="font-size:1.5rem; color: #CA1845" class="reportHeading">FILTERS:</div>
    <button id="addFilterButton" class="button button-red button-small" (click)="createFilterSubsection()">Add filter</button>

    <!-- <div id="tableContainer">
    </div> -->
    <!-- add -->
    <div class="subContainer">
      <div class="filterContainer">
        <ng-template #addFilter></ng-template>
      </div>
    </div>

    <div>
      <button id="nextButton" class="button button-red button-small" (click)="continue()">Next</button>
    </div>
  </div>
</div>
</div>
</div>
<!-- <div class="component-loader"> -->
  <ng-template #scheduling></ng-template>
<!-- </div> -->
